var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAutoAiassistant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 31.5,
    viewBox: "0 0 27 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-assistant",
    "data-name": "Icon material-assistant",
    d: "M28.5,3H7.5a3.009,3.009,0,0,0-3,3V27a3.009,3.009,0,0,0,3,3h6L18,34.5,22.5,30h6a3.009,3.009,0,0,0,3-3V6A3.009,3.009,0,0,0,28.5,3ZM20.82,19.32,18,25.5l-2.82-6.18L9,16.5l6.18-2.82L18,7.5l2.82,6.18L27,16.5Z",
    transform: "translate(-4.5 -3)",
    fill: "#ff9131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutoAiassistant);
export default __webpack_public_path__ + "static/media/ICON - Auto AI ASSISTANT.d25230b500d66f65c040216e1eeb15f0.svg";
export { ForwardRef as ReactComponent };